module.exports = __webpack_public_path__ + "static/media/bizbook-banner-2.3ef820e6.png";